// @flow
import { normalizeEntry } from './decodeUltimateChallenge';

function normalizeCompetition(c) {
  return {
    entered: c.entered,
    entries: c.entries.map(normalizeEntry),
    id: c.id,
    name: c.name,
    startTime: c.start_time
  };
}

function decodeHallOfFame(comps: Array<Object> = []) {
  return {
    competitions: comps.map(normalizeCompetition)
  };
}

export default decodeHallOfFame;
